// 湖南中烟  验证出差申请单城市的日期行程
let vaildCcsqdFor20103ParamNo = {
    data(){
      return {}
    },
    methods:{
      //验证出差申请单   param_20103("20103","0","是否开启同一申请单不同人员不同行程校验 1-开启 0-不开启 默认0"),
      vaildCcsqdFor20103(queryObj,successFn,errFn){
        let queryString = {
          "ccsqdId": queryObj.ccsqdId,
          "empIdList": queryObj.empIdList,
          "endCity": queryObj.endCity,
          "endDate": queryObj.endDate,
          "productType": queryObj.productType,
          "startCity": queryObj.startCity,
          "startDate": queryObj.startDate,
        }
       this.$conn.getConn('user.vipCcsqdBookCheck')(queryString,(res)=>{
          // code (integer, optional): 0 成功 其他失败 ,
          // message (string, optional): 失败时描述信息

          // "0 成功 1- 强提醒  2-弱提醒")
          //     private int code = 0;
          // 新增了一个 强提醒， 弱提醒的区别
          // 强提醒 就是不能继续预定， 弱提醒是 页面点 继续预定就允许预定 
          // 强提醒针对的是 时间 和酒店城市
          // 弱提醒针对  机票，火车票，用车 选择的城市不在申请单范围内

          let data = res.data || {};
          if(data.code == 0){
            successFn&&successFn(res)
          }else if(data.code == 2){ // 弱提醒  ;是否继续预订？
            this.$confirm(`${data.message}`, '温馨提示', {
                  confirmButtonText: '继续预订',
                  cancelButtonText: '重新修改',
                  type: 'warning'
            }).then(() => {
              successFn&&successFn(res)
              
            }).catch(() => {
              errFn&&errFn()             
            }); 

          } else{
            this.$alert(data.message,'温馨提示', {
							confirmButtonText: '确定',
							type:'error',
							callback: action => {
                errFn&&errFn() 
							}
						})

            // this.$message({
            //     type: 'error',
            //     message: data.message
            // });
          
          }
  
         
       },(err)=>{
        this.$message({
            type: 'error',
            message: err.tips
        });
     
       })
      }
    }
  }

export default vaildCcsqdFor20103ParamNo